import { connect }                  from 'react-redux';
import { Dispatch }                 from "redux";
import { lazy }         from 'react';

import NavBar                       from 'components/navbar';
import UserVideoMenu                from 'components/userVideoPlayer';
import Modal                        from 'components/modal';
import LoaderPage                   from 'components/loaderPage';

import {
         appTopicsArrType,
         teacherUrlStateType,
       }                            from 'types'


import { ActionTypes }              from 'actions/types';
import { reducerType }              from 'reducer';

import { componentsStateType }      from 'reducer/types';

import { SET_CHANGE_CONTENT }       from 'actions/contentActions';

const Menu = lazy(() => import('components/menu'));                     


type rootComponentsProps = {
  componentsState:    componentsStateType;
  contentTopics:      string[];
  appTopics:          appTopicsArrType[];
  teacherUrlState:    teacherUrlStateType;
  goToVideoOnce:      boolean;
  //guest:              boolean;
  setChangeContent:   (payload: boolean) => void,
  
}

const RootComponents: React.FC<rootComponentsProps> = ({
  componentsState,
  contentTopics,
  appTopics,
  teacherUrlState,
  goToVideoOnce,
  setChangeContent,
}) => {

  return (
    <>
        <Menu
          contentTopics    = { contentTopics }
          appTopics        = { componentsState.selectedContent === 'puzzles' ? [] : appTopics }
          setChangeContent = { setChangeContent }
        />          
        <NavBar/>
        { 
           componentsState.showUserVideos && 
           <UserVideoMenu/>
        }
        <LoaderPage goToVideoOnce  = { goToVideoOnce }/>
        <Modal teacherUrlState     = { teacherUrlState }/>
    </>
  );
}




const mapStateToProps = (reducer: reducerType) => {

  return {
    componentsState: reducer.components,
}};

const mapDispatchToProps = (dispatch: Dispatch<ActionTypes>) => ({
  setChangeContent: (payload: boolean) => dispatch(SET_CHANGE_CONTENT(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RootComponents);
